import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { exchangeMinsSend, exchangeMins, exchangeInfo } from "../../actions/client";
import { Helmet } from "react-helmet";
import { servicesView } from "../../actions/services";
import RatesBreadcrumbs from "../../components/Rates/RatesBreadcrumps";
import LinkC from "../../components/common/LinkC";
import { Redirect } from "react-router-dom";
import ExchangeForm from "../../components/Lk/ExchangeForm";
import LKModals from "../LK/LKModals";

class ServicesService extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = { ...ServicesService.prepareState(props),
            rate: null,
            exchangeDisabled: false,
            timeExchange: 0
        }
    }

    static prepareState = (props) => {
        let service = null;
        const { services, client } = props;
        if (!client.isGuest && services) {
            service = services.find((item) => item.id_billing == client.settings.exchange_service_id)
        } 

        const region = props.regions.selected.alias;
        return {
            service, breadcrumbs: service ? [
                {
                    url: `/${region}/services`,
                    title: 'Услуги'
                },
                {
                    url: `/${region}/services/services`,
                    title: 'Сервисы'
                },
                {
                    title: service.name
                }
            ] : null
        }
    }

    static contextTypes = {
        selectedRegion: PropTypes.object,
        fetchBefore: PropTypes.func,
        pushHistory: PropTypes.func,
    };

    componentDidMount() {

        const exchangeData = localStorage.getItem('exchange-number')?JSON.parse(localStorage.getItem('exchange-number')):null;
        const currentDate = new Date();
        const saveDate = exchangeData?new Date(exchangeData.time):0;
        const diffInSeconds = Math.floor((currentDate - saveDate) / 1000);

        if (!this.props.client.clientInfo.exchange || typeof this.props.client.clientInfo.exchange.rate === "undefined") {
            this.props.getExchangeMins(this.context.selectedRegion.id);
        }

        this.setState({
            timeExchange: saveDate,
            exchangeDisabled: 300-diffInSeconds>0
        })

        if(300-diffInSeconds<0){
            localStorage.removeItem('exchange-number')
        }


    }

    componentDidUpdate(prevProps) {
        const { clientInfo } = this.props.client;
        const exchangePhoneNumber = localStorage.getItem('exchange-number');
        const exchangeData = exchangePhoneNumber?JSON.parse(exchangePhoneNumber):null;
        const currentDate = new Date();
        const saveDate = exchangePhoneNumber!==null?exchangePhoneNumber.time:0;

        const diffInSeconds = Math.floor((currentDate - saveDate) / 1000);

        if (clientInfo.exchange && clientInfo.exchange.rate !== this.state.rate) {
            this.setState({ rate: clientInfo.exchange.rate });
        }

        if(exchangePhoneNumber && (300-diffInSeconds>0) && !this.state.exchangeDisabled){
            this.setState({exchangeDisabled: true})
        }

        if(exchangePhoneNumber && !this.state.exchangeDisabled){
            this.setState({exchangeDisabled: true})
        }

        if(exchangeData && exchangeData.isGuest){
            if(exchangeData.phoneNumber!==this.props.client.clientInfo.username){
                localStorage.removeItem('exchange-number');
                this.setState({timeExchange: 0, exchangeDisabled: false});
            }

        }

        if(!prevProps.client.exchangeMinsSuccess && this.props.client.exchangeMinsSuccess){
            this.setState({timeExchange: new Date()})
            localStorage.setItem('exchange-number', JSON.stringify({
                phoneNumber: this.props.client.clientInfo.username,
                time: new Date(),
                isGuest: false
            }));
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (!state.service && props.services.length) {
            return { ...state, ...ServicesService.prepareState(props) }
        }
        if (props.client.exchangeMinsSuccess) {
            return { ...state, modal: "exchange-success", exchangeDisabled: true }
        }
        if (props.client.exchangeMinsError) {
            return { ...state, modal: "exchange-error" }
        }
    }

    render() {
        const { service, breadcrumbs, modal } = this.state;

        const { clientInfo, formsSettings, isGuest } = this.props.client

        let canExchange = clientInfo.exchange &&
            clientInfo.exchange.is_available &&
            clientInfo.exchange.max_minutes > 0
        // if (clientInfo.exchange && (clientInfo.exchange.is_available === false || clientInfo.exchange.max_minutes === 0 || clientInfo.exchange.allowForTariff === false)) {
        //     canExchange = false;
        // }



        const parts = formsSettings.exchange_form.exchange_form_description.split('1 минута = {{rate}} Мб')


        if (isGuest || canExchange === false) {
            return <Redirect to={`/${this.context.selectedRegion.alias}/services/obmen-minut`} />
        }


        if (!service || !clientInfo.tariff) {
            return <main className="page__main-holder" role="main" />
        }


        return (
            <main className="page__main-holder page__main-holder_service" role="main">
                <Helmet
                    title={this.state.headTitle}
                    meta={[
                        { "name": "description", "content": this.state.metaDesc },
                        { "name": "keywords", "content": this.state.metaKeywords }
                    ]}>
                </Helmet>
                <div className="b-service-inner b-service-inner_adapt_default">
                    <div className="b-service-inner__service-header b-service-inner__service-header--mob">
                        <div className="b-inner-intro b-inner-intro_adapt_default">
                            <div className="b-inner-intro__wrapper exchange_wrapper">
                                <div className="b-inner-intro__inner page__container">
                                    <div className="b-inner-intro__header" />
                                    <div className={`b-inner-intro__main-area dop-size obmen-minut-inner`} >
                                        <div className="b-inner-intro__main-area-wrapper">
                                            <RatesBreadcrumbs items={breadcrumbs} />
                                            <h1 className="b-inner-intro__title">{service.name}</h1>
                                            {formsSettings.exchange_form ? <div className="b-inner-intro__text">
                                                <span>{parts[0]}</span>
                                                {this.state.rate && <span style={{color: '#f37021'}} className='rate_span'>1 мин = {this.state.rate}</span>}
                                                <span style={{color: '#f37021'}}>{parts[1]} Мб</span>
                                            </div> : null}
                                            <div className="b-inner-intro__btn">
                                                <LinkC to={'/services/' + service.slug}>Подробная информация</LinkC>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page__container">
                        <div className={'b-service-inner__content-area_top'}>
                            {clientInfo.exchange ? <ExchangeForm max={clientInfo.exchange.max_minutes}
                                rate={clientInfo.exchange.rate}
                                timeExchange={this.state.timeExchange}
                                resetExchangeTimer={()=>this.setState({exchangeDisabled: false, timeExchange:0})}
                                exchangeDisabled={this.state.exchangeDisabled}
                                title={false}
                                isSuccess={this.props.client.exchangeMinsSuccess}
                                onSubmit={this.props.exchangeMinsSend}
                                client={clientInfo}
                            /> : null
                            }
                        </div>
                    </div>
                </div>
                <LKModals modal={modal} close={() => { this.setState({ modal: null }) }} />
            </main>
        )
    }
}

export default connect(
    (state) => ({
        services: state.services.servicesLists,
        client: state.client,
        exchange: state.client.clientInfo.exchange,
        regions: state.regions,
        exchangeState: state.client.exchangeInfo.response
    }),
    (dispatch) => {
        return {
            getService: (slug, regionId) => dispatch(servicesView(slug, regionId)),
            getExchangeMins: (regionId) => dispatch(exchangeMins(regionId)),
            exchangeMinsSend: (data) => dispatch(exchangeMinsSend(data)),
            exchangeInfo: (msisdn) => dispatch(exchangeInfo(msisdn))
        }
    }
)(ServicesService);